// Module
var code = "<div title=\"{{row.entity.summary}}\" class=\"ui-grid-cell-contents\" ng-bind=\"row.entity.summary\"></div>";
// Exports
module.exports = code;